import type { IconSvgObject } from './types';

const Scooter03Icon: IconSvgObject = [
  ["circle", { cx: "12", cy: "4", r: "2", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M10 4H6", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M18 4H14", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }],
  ["path", { d: "M15 20L16.4384 20C17.7396 20 18.6943 18.7772 18.3787 17.5149L16.3787 9.51493C16.1561 8.62459 15.3562 8 14.4384 8H9.56155C8.64382 8 7.84385 8.62459 7.62127 9.51493L5.62127 17.5149C5.30569 18.7772 6.26041 20 7.56155 20L9 20", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "3" }],
  ["path", { d: "M12 18L12 22", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "4" }]
];

export default Scooter03Icon;
